import axios from 'axios';

const api = axios.create({
  // baseURL: https://homologwssite.apolar.net/
  //baseURL: 'http://localhost:2995/',
  baseURL: 'https://wssite.apolar.net/',
  auth: {
    username: 'apolar',
    password: '123',
  },
});

export default api;
